import styled from "@emotion/styled"
import Grid from "@material-ui/core/Grid"

export const StyledGridStretched = styled(Grid)`
  flex: 1;
`
